// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__Ltj7e","left":"StickyBox_left__2HE_e","right":"StickyBox_right__27_JI"};